import { Component, OnInit } from '@angular/core';
import { HighlightService } from 'src/app/@core/services/highligh.service';
import { ClipboardService } from 'ngx-clipboard'
import { ToastrService } from 'ngx-toastr';
import { ToolsService } from 'src/app/@core/services/tools.service';

@Component({
  selector: 'app-colores',
  templateUrl: './colores.component.html',
  styleUrls: ['./colores.component.scss']
})
export class ColoresComponent {

  component: any;
  utils: any;
  componentRender: any;
  infoComponent: any;
  colorSelected: any = {};
  arrColor: any[];
  highlighted: any;
  fullInfoColors: any[];
  copy = '';

  setColor(color: any) {
    // window.utils.callModal('color');
    this.utils.init();
    this.colorSelected = color;
    this.copy = `hexa copied`;
    this.updateContentModal();
    this.copyClipboard.copyFromContent(color.hexa);
    return color;
  }

  constructor(private highlightService: HighlightService,
    private tools: ToolsService,
    private copyClipboard: ClipboardService) {
    this.utils = window.utils;
    this.arrColor =
      [
        { "colorClass": "bg-color-white", "colorName": "white", "background": ["255", " 255", " 255"], "hexa": "#FFFFFF" },
        { "colorClass": "bg-color-selago", "colorName": "selago", "background": ["229", " 238", " 251"], "hexa": "#E5EEFB" },
        { "colorClass": "bg-color-dodger-blue", "colorName": "dodger-blue", "background": ["55", " 114", " 255"], "hexa": "#3772FF" },
        { "colorClass": "bg-color-marine", "colorName": "marine", "background": ["51", " 102", " 204"], "hexa": "#3366CC" },
        { "colorClass": "bg-color-dark-blue", "colorName": "dark-blue", "background": ["0", " 72", " 132"], "hexa": "#004884" },
        { "colorClass": "bg-color-green", "colorName": "green", "background": ["6", " 145", " 105"], "hexa": "#069169" },
        { "colorClass": "bg-color-gold", "colorName": "gold", "background": ["255", " 171", " 0"], "hexa": "#FFAB00" },
        { "colorClass": "bg-color-orange", "colorName": "orange", "background": ["243", " 86", " 31"], "hexa": "#F3561F" },
        { "colorClass": "bg-color-concrete", "colorName": "concrete", "background": ["242", " 242", " 242"], "hexa": "#F2F2F2" },
        { "colorClass": "bg-color-silver", "colorName": "silver", "background": ["186", " 186", " 186"], "hexa": "#BABABA" },
        { "colorClass": "bg-color-tundora", "colorName": "tundora", "background": ["75", " 75", " 75"], "hexa": "#4B4B4B" },
        { "colorClass": "bg-color-tutu", "colorName": "tutu", "background": ["255", " 242", " 250"], "hexa": "#FFF2FA" },
        { "colorClass": "bg-color-radical-red", "colorName": "radical-red", "background": ["244", " 46", " 98"], "hexa": "#F42E62" },
        { "colorClass": "bg-color-shiraz", "colorName": "shiraz", "background": ["168", " 5", " 33"], "hexa": "#A80521" },
        { "colorClass": "bg-color-pale-sky", "colorName": "pale-sky", "background": ["108", " 117", " 125"], "hexa": "#6C757D" },
        { "colorClass": "bg-color-hawkes-blue", "colorName": "hawkes-blue", "background": ["230", " 239", " 253"], "hexa": "#E6EFFD" },
        { "colorClass": "bg-color-hawkes-blue-300", "colorName": "hawkes-blue-300", "background": ["157", " 190", " 255", " 0.3"], "hexa": "#9DBEFF1E" },
        { "colorClass": "bg-color-catalina-blue", "colorName": "catalina-blue", "background": ["11", " 69", " 127"], "hexa": "#0B457F" },
        { "colorClass": "bg-color-catalina-blue-600", "colorName": "catalina-blue-600", "background": ["11", " 69", " 127", " 0.6"], "hexa": "#0B457F3C" },
        { "colorClass": "bg-color-black-160", "colorName": "black-160", "background": ["0", " 0", " 0", " 0.16"], "hexa": "#00000010" },
        { "colorClass": "bg-color-marine-400", "colorName": "marine-400", "background": ["51", " 102", " 204", " 0.4"], "hexa": "#3366CC28" },
        { "colorClass": "bg-color-dark-blue-500", "colorName": "dark-blue-500", "background": ["0", " 72", " 132", " 0.5"], "hexa": "#00488432" },
        // { "colorClass": "bg-color-white-contrast", "colorName": "white-contrast", "background": ["255", " 255", " 255"], "hexa": "#FFFFFF" },
        { "colorClass": "bg-color-shiraz-600", "colorName": "shiraz-600", "background": ["168", " 5", " 33", " 0.6"], "hexa": "#A805213C" },
        { "colorClass": "bg-color-black-contrast", "colorName": "black-contrast", "background": ["0", " 0", " 0"], "hexa": "#000000" },
        { "colorClass": "bg-color-yellow-contrast", "colorName": "yellow-contrast", "background": ["221", " 251", " 0"], "hexa": "#DDFB00" },
        { "colorClass": "bg-color-orange-contrast", "colorName": "orange-contrast", "background": ["251", " 194", " 0"], "hexa": "#FBC200" }
      ];
    this.infoComponent = {
      titulo: "Colores",
      descripcion: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Eligendi animi eaque reprehenderit, labore culpa veniam, non nulla in at voluptate cupiditate, deserunt fuga eos eius ab earum! Iste, quae inventore! "
    }

  }

  ngAfterViewChecked() {
    if (!this.highlighted) {
      this.highlightService.highlightAll();
      this.highlighted = true;
    }
  }

  ngOnInit() {
    window.utils.init();
  }

  updateContentModal() {
    const dataModal = {
      id: 'modal-colores',
      name: this.colorSelected.colorName,
      content: `      
<div class="row">
    <div class="col-7">
        <br>
        <div class="color-item color-shadow ${this.colorSelected.colorClass}">
            <div class="color-code">
                ${this.copy}
            </div>
        </div>
    </div>
    <div class="col-5" align="left">
        <hr>
        <p><b>Color: </b>${this.colorSelected.colorName}</p>
        <p><b>Clase: </b>${this.colorSelected.colorClass}</p>
        <p><b>rgb: </b>${this.colorSelected.background.length===4?'rgba':'rgb'}(${this.colorSelected.background})</p>
        <p><b>Hexa: </b>${this.colorSelected.hexa}</p>
    </div>
</div>`
    }
    this.tools.updateModalContent(dataModal);
  }
}